module.exports = __webpack_public_path__ + "ad4730a2b26c7f4f4b2484291117abe8.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_large_x1_variable/public/news/img1_3.jpg
// module id = 368
// module chunks = 0